import KnowledgebaseContainer from "../../Componant/Knowledgebase";

const Knowledgebase = () => {
  return (
    <div className="page-body">
      <KnowledgebaseContainer />
    </div>
  );
};

export default Knowledgebase;
